import { useTranslation } from 'react-i18next'
import { Search } from 'lucide-react'

interface CanvasSearchBarProps {
  value: string
  onChange: (query: string) => void
}

export function CanvasSearchBar({ value, onChange }: CanvasSearchBarProps): React.ReactElement {
  const { t } = useTranslation('analysis')

  return (
    <div className="relative flex items-center">
      <Search
        className="pointer-events-none absolute left-3 h-4 w-4"
        style={{ color: 'var(--text-muted)' }}
      />
      <input
        type="search"
        value={value}
        onChange={(ev) => {
          onChange(ev.target.value)
        }}
        placeholder={t('canvas.searchPlaceholder')}
        className="w-full rounded-md border py-2 pr-3 pl-9 text-sm transition-colors outline-none focus:border-[var(--accent)]"
        style={{
          background: 'var(--bg-card)',
          borderColor: 'var(--border)',
          color: 'var(--text)',
        }}
      />
    </div>
  )
}
